import groupApi from '../../../services/plataforma/group';

export default {
  getAll(_, { filter, sortBy, order, groupSetId }) {
    return groupApi.getAll({ filter, sortBy, order, groupSetId })
      .then(response => Promise.resolve(response.data.groups))
      .catch(e => Promise.reject(e.response.data.error));
  },
  delete(_, { groupSetId, groupId }) {
    return groupApi.delete({ groupSetId, groupId })
      .then(() => Promise.resolve())
      .catch(e => Promise.reject(e.response.data.error));
  },
  getParticipants(_, { groupSetId, groupId }) {
    return groupApi.getParticipants({ groupSetId, groupId })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  enrollToGroup(_, { groupSetId, groupId, enrollmentIds }) {
    return groupApi.enrollToGroup({ groupSetId, groupId, enrollmentIds })
      .then(() => Promise.resolve())
      .catch(e => Promise.reject(e.response.data.error));
  },
  removeParticipant(_, { groupSetId, groupId, enrollmentId }) {
    return groupApi.removeParticipant({ groupSetId, groupId, enrollmentId })
      .then(() => Promise.resolve())
      .catch(e => Promise.reject(e.response.data.error));
  },
  actionGetAllDisciplineGroupsets({ commit }, academicMainId) {
    return groupApi.getAllDisciplineGroupsets(academicMainId)
      .then(response => {
        commit('SET_GROUPSETS_SELF_REGISTRATION', response.data);
        commit('SET_GROUP_STATUS');

        return Promise.resolve();
      })
      .catch(error => Promise.reject(error.response.data.error));
  },
  actionGetGroupSet({ commit }, { academicMainId, groupSetId }) {
    return groupApi.getGroupSet({ academicMainId, groupSetId })
      .then(response => {
        commit('SET_GROUPSETS_SELF_REGISTRATION', response.data);
        commit('SET_GROUP_STATUS');

        return Promise.resolve();
      })
      .catch(error => Promise.reject(error.response.data.error));
  },
  actionStudentAutoJoinGroup({ commit }, { groupSetId, groupId, enrollmentId, isSwitchingGroups, participant }) {
    return groupApi.studentAutoJoinGroup({ groupSetId, groupId, enrollmentId })
      .then(() => {
        commit('INSERT_USER_INTO_GROUP', { groupSetId, groupId, enrollmentId, isSwitchingGroups, participant });
        commit('SET_GROUP_STATUS');

        return Promise.resolve();
      })
      .catch(error => Promise.reject(error.response.data.error));
  },
  actionDeleteDelivery(_, { mainGroupId, topicId, attemptNumber, topicType }) {
    return groupApi.deleteDelivery({ mainGroupId, topicId, attemptNumber, topicType })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  actionRemoveParticipantFromGroup(_, { groupSetId, groupId, enrollmentId, groupChangeConfiguration }) {
    return groupApi.removeParticipantFromGroup({ groupSetId, groupId, enrollmentId, groupChangeConfiguration })
      .then(() => Promise.resolve())
      .catch(e => Promise.reject(e.response.data.error));
  }
};
